<template>
  <div class="bottombar fs14">
    <div class="btn blue" @click="nav(1)">前往桌面版大赛官网</div>
    <div class="btn" @click="nav(0)">全国排名</div>
  </div>
</template>

<script>
  export default {
    name: 'MBottomBar',
    methods:{
      nav(game){
        if(game)
        {
          this.$router.replace({name:'frontpage', query:{pc: 1}})
        }
        else{
          this.$router.push({name:'rank', params:{me: 0}})
        }
      },

    }
  }
</script>

<style scoped>
  .bottombar{
    color: white;
    position: fixed;
    bottom: 0;
    width: 100vw;
    height: 12vw;
    display: flex;
  }
  .btn{
    background: #4ca2f9;
    display: flex;
    align-items:center;
    justify-content:center;
    flex: 1;
  }
  .blue{
    background: #405bee !important;
  }
</style>